import type { ApiResponse } from '@bcube/shared';
import { api } from '@/lib/api';
import type {
  AvailableConfigurationProfile,
  ProposalConfigurationResponse,
} from '@/types/commercial/proposal-configurations';

export const proposalConfigurationApi = {
  getConfigurations: async (proposalId: string): Promise<ProposalConfigurationResponse> => {
    const { data } = await api.get<ApiResponse<ProposalConfigurationResponse>>(
      `/commercial/proposals/${proposalId}/configurations`,
    );
    return data.data;
  },

  saveConfiguration: async (
    proposalId: string,
    payload: {
      groupId: string;
      profiles: Array<{ profileId: string; quantity: number }>;
    },
  ): Promise<{ groupId: string }> => {
    const { data } = await api.post<ApiResponse<{ groupId: string }>>(
      `/commercial/proposals/${proposalId}/configurations`,
      payload,
    );
    return data.data;
  },

  getAvailableProfiles: async (
    proposalId: string,
    groupId: string,
  ): Promise<AvailableConfigurationProfile[]> => {
    const { data } = await api.get<ApiResponse<AvailableConfigurationProfile[]>>(
      `/commercial/proposals/${proposalId}/configurations/profiles`,
      { params: { groupId } },
    );
    return data.data;
  },
};
